/**
 * The certificates: which checkpoints each one needs. docs/certificates.md is
 * the contract; this is the table it describes.
 *
 * Only ids and mission ids live here. The names a reader sees are strings in
 * the web app (en and ar), because a certificate's title is copy, and the
 * holder's record stores ids so a later rename cannot rewrite what was issued.
 */
/**
 * The four milestones, in course order. They partition the general track's
 * checkpoints: every checkpoint is in exactly one, or in TRACK_CHECKPOINTS
 * below, which a test holds against VERIFICATION_MISSIONS, together with every
 * one being salted.
 */
const MILESTONES = [
    { id: 'version-control', missions: ['cp-first-commits', 'cp-remotes', 'cp-recovery', 'cp-quality', 'cp-team-git', 'cp-code-review'] },
    { id: 'shipping', missions: ['cp-the-codebase', 'cp-releases', 'cp-production', 'cp-pipeline', 'cp-data', 'cp-design', 'cp-ownership'] },
    { id: 'systems', missions: ['cp-network', 'cp-database', 'cp-api', 'cp-security', 'cp-concurrency', 'cp-observability', 'cp-scale-and-cost'] },
    { id: 'senior-work', missions: ['cp-legacy', 'cp-configuration', 'cp-craft', 'cp-engineer', 'cp-whole-job'] },
];
/**
 * Checkpoints of a specialization track (docs/ai-track.md). Each earns its
 * world a badge on the public page like any other, and none is on a
 * certificate: a certificate, and the project board's gate, describe the
 * general course, and a track is a path somebody chooses rather than a bar
 * everybody has to clear. Listed rather than inferred so that a checkpoint
 * cannot fall off every certificate without somebody deciding it should.
 */
export const TRACK_CHECKPOINTS = ['cp-agent-review'];
/** The milestones and then the whole course, which is their union rather than a list of its own to drift. */
export const CERTIFICATES = [
    ...MILESTONES,
    { id: 'engineer', missions: MILESTONES.flatMap((m) => m.missions) },
];
export function certificateDefinition(id) {
    return CERTIFICATES.find((c) => c.id === id);
}
/**
 * `EOS-XXXX-XXXX-XXXX`: sixty random bits in Crockford base32 (no I, L, O or
 * U, so it survives being read aloud or retyped). Unguessable on purpose: the
 * public route answers a name for a valid id.
 */
const CROCKFORD = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';
export const CERTIFICATE_ID_PATTERN = /^EOS-[0-9A-HJKMNP-TV-Z]{4}-[0-9A-HJKMNP-TV-Z]{4}-[0-9A-HJKMNP-TV-Z]{4}$/;
export function newCertificateId(random) {
    const bytes = random(new Uint8Array(12));
    let body = '';
    for (let i = 0; i < 12; i++)
        body += CROCKFORD[bytes[i] & 31];
    return `EOS-${body.slice(0, 4)}-${body.slice(4, 8)}-${body.slice(8)}`;
}
//# sourceMappingURL=certificates.js.map